import { useEffect } from 'react';

import useHistory from 'routing/useHistory';

import GraphRoutes from './Routes';

const GraphInputConfiguration = () => {
  const history = useHistory();

  useEffect(() => {
    const url = GraphRoutes.INTEGRATIONS.Graph.ACTIVITYAPI.index;
    history.push(url);
  }, [history]);

  return null;
};

export default GraphInputConfiguration;
